<template>
    <div
        class="custom-option"
        :class="{
            'active' : showOptions,
            'up' : pullUp
        }"
        @click="showOptions=!showOptions"
        @blur="showOptions=false"
        tabindex="0"
    >
        <div
            class="selected"
        >
            {{ value || placeholder }}
        </div>

        <ul v-if="showOptions && options.length > 0">
            <li
                class="option"
                v-for="option in options"
                :key="option"
                :class="{'selected' : option === value}"
                @click="$emit('input', option)"
            >
                {{ option }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
	props: {
		options: {
			type: Array,
			required: true
		},

		placeholder: {
			type: String,
			required: true
		},

		value: {
			type: String,
			default: null
		},

		pullUp: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			showOptions: false
		}
	}
}
</script>

<style lang="scss" scoped>
.custom-option {
    position: relative;
    border: 1px solid #d0d0df;
    padding: 5px 10px;
    min-width: 90px;
    border-radius: 5px;
    font-size: 1em;
    height: 2.3em;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;

    &:after {
        content: '';
        display: inline-block;
        border-top: 2px solid #7A7D7E;
        border-right: 2px solid #7A7D7E;
        height: 5px;
        width: 5px;
        transform: rotateZ(135deg);
        pointer-events: none;
        margin-bottom: 2px;
    }

    .selected {
        flex: 1 1 auto;
        color: #777;
        line-height: 18px;
        margin-right: 5px;
    }

    ul {
        position: absolute;
        top: 100%;
        left: 0;
        width: 100%;
        max-height: 400px;
        overflow: auto;
        background-color: #fff;
        border-radius: 5px;
        border: 1px solid #D9DEE2;
        padding: 0;
        list-style: none;
        margin-top: 10px;
        min-height: 25px;

        li {
            padding: 10px;
            width: 100%;
            font-size: 0.9rem;

            &.selected , &:hover {
                background-color: #eee;
            }
        }
    }

    &.active,
    &:focus,
    &.active ul,
    &:focus ul {
        border-color: #2DC4B6;
        outline: none;
    }

    &.up {
        &:after {
            transform: rotateZ(-45deg);
            margin-bottom: 0;
            margin-top: 2px;
        }

        ul {
            top: unset;
            bottom: 100%;
            margin-top: 0;
            margin-bottom: 10px;
        }
    }
}
</style>
